import React from "react";
import { PropTypes } from "prop-types";
import { observer } from "mobx-react";
import { applicationDefaults } from "common/constants";
import { MrbApplicationFormatter, mrbDefaultFormats } from "mrb/common/formatting";

const formatter = new MrbApplicationFormatter();

function AppReleaseLatestVersionTemplate({ latestVersion, t }) {
    return (
        <div className="c-card--primary u-mar--bottom--sml">
            {latestVersion ? (
                <div className="u-display--flex u-display--flex--wrap u-display--flex--ai--center u-gap--med">
                    {latestVersion.downloadUrl && (
                        <a
                            className="c-btn c-btn--sml c-btn--ghost"
                            href={latestVersion.downloadUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t("ADMINISTRATION.APP_RELEASE.LATEST.DOWNLOAD")}
                        </a>
                    )}
                    <div className="u-display--flex u-display--flex--1 u-display--flex--wrap u-gap--med">
                        <MetaField label={t("ADMINISTRATION.APP_RELEASE.LATEST.TITLE")}>
                            <p className="u-type--med u-type--wgt--bold">{latestVersion.version}</p>
                        </MetaField>
                        <MetaField label={t("ADMINISTRATION.APP_RELEASE.LATEST.CODE")}>
                            <p className="u-type--base">{latestVersion.versionCode}</p>
                        </MetaField>
                        {latestVersion.publishTime && (
                            <MetaField label={t("ADMINISTRATION.APP_RELEASE.LATEST.PUBLISHED")}>
                                <p className="u-type--base">
                                    {formatter.format(mrbDefaultFormats.date, latestVersion.publishTime, {
                                        format: applicationDefaults.formats.dateTime,
                                    })}
                                </p>
                            </MetaField>
                        )}
                        {latestVersion.updateMessage && (
                            <MetaField
                                className="u-display--flex--1 u-width--200--min"
                                label={t("ADMINISTRATION.APP_RELEASE.LATEST.RELEASE_NOTES")}
                            >
                                <p className="u-type--base">{latestVersion.updateMessage}</p>
                            </MetaField>
                        )}
                    </div>
                </div>
            ) : (
                <MetaField label={t("ADMINISTRATION.APP_RELEASE.LATEST.TITLE")}>
                    <p className="u-type--base u-type--color--opaque">{t("ADMINISTRATION.APP_RELEASE.LATEST.EMPTY")}</p>
                </MetaField>
            )}
        </div>
    );
}

AppReleaseLatestVersionTemplate.propTypes = {
    latestVersion: PropTypes.object,
    t: PropTypes.func,
};

function MetaField({ label, className, children }) {
    return (
        <div className={className}>
            <p className="u-type--sml u-type--color--opaque">{label}</p>
            {children}
        </div>
    );
}

export default observer(AppReleaseLatestVersionTemplate);
